import React from "react";
import { ArrowRight, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BuffalosGreenConnection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="59566" id="pittsburghs-landscape-experts" className="relative w-full overflow-hidden bg-background py-20 lg:py-32 dark">
      {}
      <div className="absolute inset-0 z-0 opacity-[0.05] pointer-events-none text-primary">
        <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
          <defs>
            <pattern id="topo-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <path d="M0 100 C 20 0 50 0 100 100 Z" fill="none" stroke="currentColor" strokeWidth="0.5" />
              <path d="M0 50 C 20 0 80 0 100 50 Z" fill="none" stroke="currentColor" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#topo-pattern)" />
        </svg>
      </div>

      <div ref={ref} className={`relative z-10 grid gap-12 lg:grid-cols-2 lg:gap-8 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        {}
        <div className="flex flex-col items-start space-y-6 text-left px-4 md:px-6 lg:px-12">
          <Badge variant="outline" className="inline-flex items-center justify-center rounded-md border w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-accent [a&]:hover:text-accent-foreground border-accent/30 bg-accent/10 text-accent px-3 py-1 font-medium tracking-wide uppercase backdrop-blur-sm dark:aria-invalid:ring-destructive/40">SERVING YOUR COMMUNITY & SURROUNDING AREAS</Badge>

          <h1 className="font-serif text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl lg:text-7xl lg:leading-[1.1]">Premium Landscaping<br /><font color="#80b395">for Homes That Stand Out</font></h1>

          <p className="max-w-[600px] font-sans text-lg text-muted-foreground md:text-xl leading-relaxed">We help homeowners improve curb appeal with clean landscaping, reliable service, and polished results.</p>

          <div className="flex flex-col gap-4 sm:flex-row pt-4">
            <Button asChild size="lg" className="group relative overflow-hidden bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/20 transition-all hover:shadow-xl hover:shadow-primary/30">
              <Link to="/Get an Estimate">
                <span className="relative z-10 flex items-center gap-2">Get a Free Estimate<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/BuffalosGreenConnection.tsx|sig:38k69z" data-ast-start="3080" data-ast-end="3161"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></span>
                {}
                <span className="absolute inset-0 z-0 animate-pulse bg-white/10 opacity-0 group-hover:opacity-100" />
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="border-accent/40 text-accent hover:bg-accent/10 hover:text-accent shadow-sm">
           <a href="#our-professional-services">View Our Work</a>
            </Button>
          </div>
        </div>

        {}
        <div className="relative mx-auto w-full max-w-[600px] lg:max-w-none px-4 md:px-6 lg:px-12">
          <div className="relative aspect-[4/3] w-full overflow-hidden lg:aspect-square">
            {}
            <div className="absolute -right-10 -top-10 h-64 w-64 rounded-full bg-accent/20 blur-3xl filter" />
            <div className="absolute -bottom-10 -left-10 h-64 w-64 rounded-full bg-primary/20 blur-3xl filter" />

            {}
            <div className="relative h-full w-full overflow-hidden rounded-[2rem] lg:rounded-[30%_70%_70%_30%_/_30%_30%_70%_70%] shadow-2xl shadow-primary/20 transition-all duration-500 hover:scale-[1.02]">
              <div className="absolute inset-0 bg-gradient-to-t from-primary/40 to-transparent z-10" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/image_1njm9avd.png" alt="Professional landscaping project by Nieser Landscaping" className="h-full w-full object-cover object-center" />
            </div>

            
          </div>
        </div>
      </div>
    </section>;
}